import * as React from 'react';
import { useHistory } from 'react-router';
import styled from 'styled-components';
import errorPago from '@/assets/illustrations/error-pago.svg';
import Button from '@/presentation/reusables/Button';
import routes from './Routes/routingMap';

const Container = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 42px;
  flex-direction: column;
  align-items: center;
  font-family: Lato;
  gap: 32px;

  & .titleError {
    font-size: 16px;
    line-height: 24px;
    text-align: center;
    color: #161d1f;
    font-weight: 700;
  }

  & .messageError {
    color: #4f6168;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
  }

  & .contentText {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }
`;

const ContainerButtons = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
  width: 100%;

  @media (min-width: 640px) {
    flex-direction: row;
  }
`;

const ErrorPayments = () => {
  const history = useHistory();
  const handlerHome = () => {
    history.push(routes.student.main.home);
  };
  const handlerReload = () => {
    window.location.reload();
  };
  return (
    <Container>
      <img src={errorPago} alt="" />
      <div className="contentText">
        <p className="titleError">Estamos procesando tu información de pagos</p>
        <p className="messageError">
          Tenemos algunos inconvenientes con los pagos en este momento. Intenta
          de nuevo más tarde.
        </p>
      </div>
      <ContainerButtons>
        <Button onClick={() => handlerHome()} text="Ir a inicio" />
        <Button
          outlined
          onClick={() => handlerReload()}
          text="Volver a cargar"
        />
      </ContainerButtons>
    </Container>
  );
};

export default ErrorPayments;
